export default {
  SET_KPUS(state, kpus) {
    state.kpus = kpus
  },
  SET_PROJECT_LEADERS(state, users) {
    state.projectLeaders = users
  },
  SET_KEY_PROJECT_TYPES(state, keyProjectTypes) {
    state.keyProjectTypes = keyProjectTypes
  },
  ADD_KEY_PROJECT_TYPE(state, keyProjectType) {
    state.keyProjectTypes.unshift(keyProjectType)
  },
  UPDATE_KEY_PROJECT_TYPE(state, keyProjectType) {
    const index = state.keyProjectTypes.findIndex((t) => t.id === keyProjectType.id)
    Object.assign(state.keyProjectTypes[index], keyProjectType)
  },
  REMOVE_KEY_PROJECT_TYPE(state, id) {
    const index = state.keyProjectTypes.findIndex((t) => t.id === id)
    state.keyProjectTypes.splice(index, 1)
  },
  SET_KEY_PROJECTS(state, keyProjects) {
    state.keyProjects = keyProjects
  },
  ADD_KEY_PROJECT(state, keyProject) {
    state.keyProjects.unshift(keyProject)
  },
  UPDATE_KEY_PROJECT(state, keyProject) {
    const index = state.keyProjects.findIndex((t) => t.id === keyProject.id)
    Object.assign(state.keyProjects[index], keyProject)
  },
  REMOVE_KEY_PROJECT(state, id) {
    const index = state.keyProjects.findIndex((t) => t.id === id)
    state.keyProjects.splice(index, 1)
  }
}
